var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPot1Copy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "72.000000pt",
    height: "72.000000pt",
    viewBox: "0 0 72.000000 72.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,70.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180 669 c0 -3 6 -12 14 -18 27 -23 25 -73 -4 -111 -25 -32 -48 -90 -65 -164 -12 -57 14 -176 58 -265 51 -101 67 -111 177 -111 110 0 126 10 177 111 44 89 70 208 58 265 -17 74 -40 132 -65 164 -29 38 -31 88 -4 111 8 6 14 15 14 18 0 4 -81 7 -180 7 -99 0 -180 -3 -180 -7z",
    fill: "#000000",
    stroke: "#ffffff",
    strokeWidth: 64
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPot1Copy);
export default __webpack_public_path__ + "static/media/pot1 - Copy.3baaff21c5525ed62ea5b8e045a8935b.svg";
export { ForwardRef as ReactComponent };